import React from "react";

import { Avatar, CardHeader, ButtonBase } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";
import { getContactDisplayName } from "../../helpers/contactDisplayName";

const useStyles = makeStyles((theme) => ({
  trigger: {
    borderRadius: 8,
    display: "block",
    maxWidth: "100%",
    textAlign: "left",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#f4f7fb",
    },
  },
  info: {
    minWidth: 0,
    padding: theme.spacing(0.5, 1),
  },
  title: {
    fontSize: 14,
    fontWeight: 800,
  },
  subheader: {
    color: theme.palette.type === "dark" ? "#9aa5b8" : "#718096",
    fontSize: 11,
    marginTop: 2,
  },
  avatar: {
    height: 40,
    width: 40,
  },
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
	const classes = useStyles();
	const assignedTo = ticket.user
		? `${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
		: "Sin asignar";
	const contactReference = contact.number || `Ticket #${ticket.id}`;
	const displayName = getContactDisplayName(contact);

	return (
		<ButtonBase
			aria-label="Abrir información del contacto"
			className={classes.trigger}
			onClick={onClick}
		>
			<CardHeader
				className={classes.info}
				titleTypographyProps={{ className: classes.title, noWrap: true }}
				subheaderTypographyProps={{ className: classes.subheader, noWrap: true }}
				avatar={<Avatar className={classes.avatar} src={contact.profilePicUrl} alt={displayName} />}
				title={displayName}
				subheader={`${contactReference} · ${assignedTo}`}
			/>
		</ButtonBase>
	);
};

export default TicketInfo;
